<template>
  <multiselect
    :model-value="selectedOption"
    track-by="id"
    label="name"
    :allow-empty="false"
    :show-labels="false"
    :options="options"
    @update:model-value="optionSelected" />
</template>

<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue';
  import { Multiselect } from 'vue-multiselect';

  import ChartEvents from '@/common/enums/chart-events.enum';
  import ChartAction from '@/common/models/chart/ChartAction';
  import ChartGroupAction from '@/common/models/chart/ChartGroupAction';

  interface IProps {
    action: ChartGroupAction;
  }

  const { action } = defineProps<IProps>();

  interface IEmits {
    (e: ChartEvents.OPTION_SELECTED, value: ChartAction): void;
  }

  const emits = defineEmits<IEmits>();

  const selectedOption = ref(null);

  const options = computed(() => {
    return (
      action?.options?.map((o) => ({
        isDefault: o.isSelected,
        name: o.label,
        id: o.id,
        $isDisabled: !o.enabled,
      })) || []
    );
  });

  onMounted(() => {
    const option = action?.options?.find((o) => o.isSelected);
    if (option) {
      selectedOption.value = { isDefault: option.isSelected, name: option.label, id: option.id };
    }
  });

  function optionSelected(option) {
    const selectedOption = action.options.find((o) => option.id === o.id);
    if (selectedOption.enabled) {
      emits(ChartEvents.OPTION_SELECTED, selectedOption);
    }
  }
</script>

<style lang="scss" scoped></style>
